import(/* webpackMode: "eager" */ "/app/app/buy-used-cars/vehicle/[slug]/error.tsx");
